<template>
	<v-dialog v-model="otc" width="300">
		<template v-slot:activator="{ on }">
			<v-btn icon v-on="on" >
				<v-icon
					large
					v-on="on"
				>
					mdi-calendar-text-outline
				</v-icon>
			</v-btn>
		</template>
		<v-card>
			<v-card-title class="headline grey lighten-2" primary-title>One Time Code</v-card-title>
			<v-card-text ref="otc">
				<div v-for="(code) in pending_otcs" :key="code" class="text-center font-weight-black">{{code}}</div>
				<div
					v-for="(tag) in installation_tags"
					:key="tag.id"
					class="text-center text-disable"
				>{{tag.vehicle_name ? tag.install_tag + ' => ' +tag.vehicle_name : tag.install_tag}}</div>
			</v-card-text>
			<v-divider></v-divider>
			<v-card-actions>
				<v-btn color="primary" text @click="otc = false">Close</v-btn>
				<div class="flex-grow-1"></div>

				<v-btn color="primary" text @click="copy">Copy</v-btn>

				<v-btn color="primary" text @click="mailTo">Mail</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	import { AmplifyEventBus } from "aws-amplify-vue";
	import { Logger } from "aws-amplify";
	const logger = new Logger("OTC");
	export default {
		props: {
			task: {
				required: true,
				type: Object
			}
		},

		data: () => ({
			otc: false
		}),

		computed: {
			pending_otcs() {
				if (!this.task.context.pending_otc) return [];
				const pending_otcs = this.task.context.pending_otc;
				return pending_otcs;
			},
			installation_tags() {
				if (!this.task.context.devices) return [];
				const installation_tags = this.task.context.devices; //.map(
				// 	tag => tag.installation_tag
				// );
				return installation_tags;
			}
		},

		methods: {
			async copy() {
				logger.debug(this);
				const res = this.task.context.pending_otc; //.concat(this.installation_tags.map(tag => tag.installation_tag));
				try {
					await navigator.clipboard.writeText(res.join("\n"));
					AmplifyEventBus.$emit("snackEvent", {
						color: "black",
						text: `one time code copied!`
					});
				} catch (error) {
					AmplifyEventBus.$emit("snackEvent", {
						color: "error",
						text: `please check permission setting!`
					});
				}
			},

			mailTo() {
				const res = this.pending_otcs; //.concat(this.installation_tags);
				const link = `mailto:${
					this.task.assigned_to
				}?subject=One Time Code&body=${encodeURIComponent(res.join("\n"))}`;
				// const a = document.createElement("a");
				// a.href = link;
				// a.click();
				window.open(link);
			}
		}
	};
</script>

<style lang="css">
	.text-disable {
		text-decoration: line-through;
		color: grey;
	}
</style>